<template>
  <main>
    <UContainer>
      <slot />
    </UContainer>
  </main>
</template>
